import { useConfiguration } from '@travel-frontend/core';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { firstLetterUpperCase } from '../../components/Authentication/helpers.js';
import { checkToken, doLogin, doLogout, getProfileInfo, getUserStatus, refreshToken, resetErrors, setToken, toggleComponent, verifyCustomer } from '../../components/Authentication/redux/actions.js';
import { currentComponent as currentComponentSelector, isLoggedIn as isLoggedInSelector, isPending as isPendingSelector, isServiceAgent as isServiceAgentSelector, profileData as profileDataSelector, status as statusSelector } from '../../components/Authentication/redux/reducer.js';
export const useAuthentication = () => {
  const isLoggedIn = useSelector(isLoggedInSelector);
  const userInfo = useSelector(statusSelector);
  const profileData = useSelector(profileDataSelector);
  const isServiceAgent = useSelector(isServiceAgentSelector);
  const currentComponent = useSelector(currentComponentSelector);
  const isStatusPending = useSelector(isPendingSelector);
  const dispatch = useDispatch();
  const authUrl = useConfiguration('authUrl');
  const signIn = useCallback((credentials, onSuccess, onFail) => {
    // @ts-expect-error FIXME
    dispatch(doLogin(authUrl, credentials, onSuccess, onFail));
  }, [authUrl, dispatch]);
  const signOut = useCallback(() => {
    dispatch(doLogout());
  }, [dispatch]);
  const handleOpenComponent = useCallback((type, component) => {
    dispatch(resetErrors());
    dispatch(toggleComponent(type, component));
  }, [dispatch]);
  const isComponentOpen = useCallback((type, component) => {
    const selectedComponent = `${component}${firstLetterUpperCase(type)}`;
    return selectedComponent === currentComponent;
  }, [currentComponent]);
  const getStatus = useCallback(() => {
    // @ts-expect-error FIXME
    dispatch(getUserStatus(authUrl));
  }, [authUrl, dispatch]);
  const getProfileData = useCallback(() => {
    // @ts-expect-error FIXME
    dispatch(getProfileInfo(authUrl));
  }, [authUrl, dispatch]);
  return useMemo(() => ({
    isLoggedIn,
    userInfo,
    profileData,
    isServiceAgent,
    isStatusPending,
    getProfileData,
    doLogin: signIn,
    doLogout: () => signOut(),
    // @ts-expect-error FIXME
    refreshToken: () => dispatch(refreshToken(authUrl)),
    // @ts-expect-error FIXME
    checkToken: token => dispatch(checkToken(authUrl, token)),
    getUserStatus: () => getStatus(),
    verifyCustomer: token =>
    // @ts-expect-error FIXME
    dispatch(verifyCustomer(authUrl, token)),
    setToken: token => dispatch(setToken(token)),
    toggleWidget: component => handleOpenComponent('widget', component),
    toggleDialog: component => handleOpenComponent('dialog', component),
    isComponentOpen: (type, component) => isComponentOpen(type, component)
  }), [isLoggedIn, userInfo, profileData, isServiceAgent, isStatusPending, getProfileData, signIn, getStatus, signOut, dispatch, authUrl, handleOpenComponent, isComponentOpen]);
};